import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './QuickEnquiry.module.css';
import api from '../../services/api';
import AppContext from '../../context/AppContext';

const QuickEnquiry = () => {
  const { isEnquiryOpen, openEnquiry, closeEnquiry } = useContext(AppContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', phone: '', course: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Show popup shortly after every page load as requested
    const timer = setTimeout(() => {
      openEnquiry();
    }, 1500);

    return () => clearTimeout(timer);
  }, [openEnquiry]);

  const handleClose = () => {
    closeEnquiry();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.name || !form.phone || !form.course) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await api.post('/enquiry', {
        name: form.name,
        phone: form.phone,
        program: form.course,
        message: 'Quick Enquiry from popup'
      });
      // Close popup immediately and go to Thank You page
      closeEnquiry();
      setForm({ name: '', phone: '', course: '' });
      navigate('/thank-you');
    } catch (err) {
      const apiError = err.response?.data;
      const errorMessage = typeof apiError === 'string'
        ? apiError
        : (apiError?.message || apiError?.error || err.message || 'Failed to submit. Please try again.');
      
      // If it's a network error or generic server failure, navigate to error page
      if (!err.response || err.response.status >= 500 || err.message === 'Network Error') {
        closeEnquiry();
        navigate('/error', { state: { isError: true, message: errorMessage } });
      } else {
        // Validation errors (400) stay in the popup
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isEnquiryOpen) return null;

  return (
    <>
      <div className={styles.overlay} onClick={handleClose} />
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={handleClose}>✕</button>
        
        <>
          <h2 className={styles.title}>Quick Enquiry</h2>
          <p className={styles.subtitle}>Get a callback within 24 hours</p>

          <form onSubmit={handleSubmit} className={styles.form}>
              {error && <div className={styles.error}>{error}</div>}

              <div className={styles.field}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={handleChange}
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.field}>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={handleChange}
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.field}>
                <select
                  name="course"
                  value={form.course}
                  onChange={handleChange}
                  className={styles.input}
                  required
                >
                  <option value="">Select Course</option>
                  <option value="Air Hostess Training">Air Hostess Training</option>
                  <option value="Airport Management">Airport Management</option>
                  <option value="Customer Service Executive">Customer Service Executive</option>
                </select>
              </div>

              <button
                type="submit"
                className={styles.submitBtn}
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Get Callback'}
              </button>
            </form>
          </>
      </div>
    </>
  );
};

export default QuickEnquiry;
